import { Injectable } from "@angular/core";
import { DashboardService } from '../dashboard.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { NewItemsCount } from '../../models/new-items-count.model';

@Injectable({
    providedIn: 'root'
})
export class DashboardStoreService {

    private fetchSubscription: Subscription;

    private readonly _newItemsCount = new BehaviorSubject<NewItemsCount>(new NewItemsCount());


    readonly newItemsCount$ = this._newItemsCount.asObservable();

    constructor(private dashboardService: DashboardService) { }


    get newItemsCount(): NewItemsCount {
        return this._newItemsCount.getValue();
    }

    set newItemsCount(newItemsCount: NewItemsCount) {
        this._newItemsCount.next(newItemsCount);
    }

    fetch() {
        this.fetchSubscription = this.dashboardService.fetchDashboardNewItemsCount()
            .subscribe(newItemsCount => this.newItemsCount = newItemsCount);
    }

    clean() {
        if (this.fetchSubscription) {
            this.fetchSubscription.unsubscribe();
        }
        this.newItemsCount = new NewItemsCount();

    }
}